import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
} from "react-router-dom";
import SearchNav from "./function-components/Searchnav";
import Navbarmenu from "./function-components/Navbar/Navbarmenu";
import Footer from "./function-components/Footer";
import Home from "./pages/Home";
import Faq from "./pages/Faq";
import WallOfFame from "./pages/WallOfFame";
import ContactUs from "./pages/ContactUs";
import OurLeads from "./pages/OurLeads";
import Learning from "./pages/Learning";
import { MsalProvider } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";
import { PageLayout } from "./function-components/PageLayout";
import Dashboard from "./pages/Dashboard";
import JapaneseLearning from "./pages/JapaneseLearning";
import DashboardJapanese from "./pages/DashboardJapanese";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import EventsContent from "./function-components/EventsContent";
import { useLocation } from "react-router-dom";
import AnalyticsPage from "./function-components/AnalyticsPage";

function App({ pca }) {
  // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
  const history = useHistory();
  const navigationClient = new CustomNavigationClient(history);

  pca.setNavigationClient(navigationClient);

  return (
    <MsalProvider instance={pca}>
      <PageLayout>
        <div container justifyContent="center">
          <Pages />
        </div>
      </PageLayout>
    </MsalProvider>
  );
}
function Pages() {
  const msalInstance = new PublicClientApplication(msalConfig);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  useEffect(() => {
    console.log('0');
    if (activeAccount) {
      console.log('1');
      fetchAccessToken()
      console.log('2');
    }
  }, [activeAccount]);
  const fetchAccessToken = async () => {
    if (!activeAccount)
      throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    try {
      console.log(activeAccount);
      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: activeAccount
      });
      const bearer = `Bearer ${response.accessToken}`;
      console.log(bearer);
      localStorage.setItem("token", bearer)
      console.log("inside try block");
    }
    catch (error) {
      console.error('Error fetching access token:', error);
      localStorage.clear()
    }
  };

  const [value, setValue] = React.useState(0); //events page state

  // for Learning page
  const location = useLocation();
  const selectedLanguage = location.state
    ? location.state.selectedLang
    : "French";

  const [languageValue, setLanguageValue] = useState(selectedLanguage);

  return (
    <>
      <Router>
        <SearchNav />
        <Navbarmenu />
        <Switch>
          <Route exact path="/home">
            <Home value={value} setValue={setValue} languageValue={languageValue} setLanguageValue={setLanguageValue}/>
          </Route>
          <Route exact path="/">
            <Home value={value} setValue={setValue} />
          </Route>
          <Route exact path="/learnings">
            <Learning languageValue={languageValue} setLanguageValue={setLanguageValue} />
          </Route>
          <Route exact path="/japaneseLearning">
            <JapaneseLearning />
          </Route>
          <Route exact path="/wallOfFame">
            <WallOfFame />
          </Route>
          <Route exact path="/ourTeam">
            <OurLeads />
          </Route>

          <Route exact path="/dashboard">
            <Dashboard />
          </Route>
          <Route exact path="/dashboardJapanese">
            <DashboardJapanese />
          </Route>
          <Route exact path="/faqs">
            <Faq />
          </Route>
          <Route exact path="/learningBytes">
            <EventsContent value={value} setValue={setValue} />
          </Route>
          <Route exact path="/contactUs">
            <ContactUs />
          </Route>
          <Route exact path="/analytics">
            <AnalyticsPage/>
          </Route>
        </Switch>
        <Footer />
      </Router>
    </>
  );
}
//check commit2
export default App;
